// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_wowjs.js";
import "./modules/parallax.js";

var $tdentWindow = jQuery(window);
var $tdentDocument = jQuery(document);
var $tdentBody = jQuery("body");
//const bodyScrollLock = require("body-scroll-lock");
//const disableBodyScroll = bodyScrollLock.disableBodyScroll;
//const enableBodyScroll = bodyScrollLock.enableBodyScroll;
var tdentScrollWidth = 0;

function getScrollWidth() {
  var div = document.createElement("div");

  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.visibility = "hidden";
  div.style.position = "absolute";
  div.style.top = "0px";
  div.style.left = "-900px";

  $tdentDocument.ready(() => {
    document.body.appendChild(div);

    tdentScrollWidth = div.offsetWidth - div.clientWidth;

    document.body.removeChild(div);
  });
}

function windowWidth() {
  var e = window,
    a = "inner";
  var windowWidth;

  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }

  windowWidth = e[a + "Width"];

  return windowWidth;
}

function windowHeight() {
  var e = window,
    a = "inner";
  var windowHeight;

  if (!("innerHeight" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }

  windowHeight = e[a + "Height"];

  return windowHeight;
}

function tdentHandleAnchorLinks() {
  $tdentDocument.on("click", "a", function(event) {
    var $link = $(this);
    var url = $link.attr("href");
    var hashPosition = -1;

    if (url) {
      hashPosition = url.indexOf("#");
    }

    if (hashPosition !== -1) {
      var hash = url.substring(hashPosition + 1);
      var $target = $("#" + hash);

      if ($target.length) {
        event.preventDefault();

        var targetOffset = $target.offset().top;
        var $headerInit = $("#tdent-header__part--init");
        var $headerFixed = $("#tdent-header__part--fixed");

        if ($headerInit.length && $headerFixed.length) {
          var headerInitHeight = 0;
          var headerFixedHeight = 0;
          var initInactive = false;
          var fixedInactive = false;

          if (!$headerInit.hasClass("active")) {
            initInactive = true;

            $headerInit.addClass("active");
          }

          if (!$headerFixed.hasClass("active")) {
            fixedInactive = true;

            $headerFixed.addClass("active");
          }

          setTimeout(function() {
            var screenWidth = windowWidth();
            var koefficientInit = 0.5;
            var koefficientFixed = 0.75;

            if (screenWidth <= 567) {
              koefficientInit = 0.2;
              koefficientFixed = 0.4;
            }

            headerInitHeight = $headerInit.innerHeight();
            headerFixedHeight = $headerFixed.innerHeight();

            if (initInactive) {
              $headerInit.removeClass("active");
            }

            if (fixedInactive) {
              $headerFixed.removeClass("active");
            }

            setTimeout(function() {
              if (headerInitHeight * koefficientInit > targetOffset) {
                targetOffset -= headerInitHeight;
              } else if (headerFixedHeight * koefficientFixed <= targetOffset) {
                targetOffset -= headerFixedHeight;
              }

              $("html, body").animate({ scrollTop: targetOffset }, 700);
            }, 100);
          }, 300);
        } else {
          $("html, body").animate({ scrollTop: targetOffset }, 700);
        }
      }
    }
  });
}

function tdentHandleButtonsFocus() {
  $(document).on("mouseleave", "button, a", function() {
    if (!$(this).hasClass("sl-next") && !$(this).hasClass("sl-prev")) {
      this.blur();
    }
  });
}

function tdentFixPlaceholders() {
  var $inputs = $("input,textarea");

  if ($inputs.length) {
    $inputs.each(function() {
      $(this).data("holder", $(this).attr("placeholder"));

      $(this).focusin(function() {
        $(this).attr("placeholder", "");
      });

      $(this).focusout(function() {
        $(this).attr("placeholder", $(this).data("holder"));
      });
    });
  }
}

function tdentFixFrames() {
  var $frames = $(".tdent-article iframe, .tdent-entry iframe");

  if ($frames.length) {
    $frames.each(function() {
      var $this = $(this);

      if (
        (!$this.attr("id") ||
          ($this.attr("id") && $this.attr("id").indexOf("gform") === -1)) &&
        !$this.hasClass("tdent-reviews-frame")
      ) {
        var $frameParent = $this.parent();
        var width = $this.attr("width");
        var height = $this.attr("height");
        var padding = "";
        var sizes = "";

        if (width && height) {
          if (width === "100%") {
            width = 1300;
            height = 730;
          } else if (height === "100%" && width !== "100%") {
            height = 730;
            width = height * 1.78;
          } else {
            width = parseInt(width, 10);
            height = parseInt(height, 10);
          }

          padding = (height / width) * 100;
          sizes =
            ' style="max-width: ' +
            width +
            "px; " +
            "max-height: " +
            height +
            'px;"';
        }

        if ($frameParent.prop("tagName") !== "P") {
          if (padding) {
            padding = ' style="padding-bottom: ' + padding + '%;"';
          }

          $this.wrap(
            '<div class="tdent-iframe-wrap-outer"' +
              (sizes ? sizes : "") +
              '><p class="tdent-iframe-wrap"' +
              padding +
              "></p></div>"
          );
        } else if (!$frameParent.hasClass("tdent-iframe-wrap")) {
          $frameParent.addClass("tdent-iframe-wrap");

          if (padding) {
            $frameParent.css("padding-bottom", padding + "%");
          }

          $frameParent.wrap(
            '<div class="tdent-iframe-wrap-outer"' +
              (sizes ? sizes : "") +
              "></div>"
          );
        }
      }
    });
  }
}

function tdentFixNextGenShutter() {
  $(document).on("click", function(event) {
    var $target = $(event.target);

    if ($target.length && $target.parents("#shDisplay").length) {
      if (
        $target.attr("id") !== "shTopImg" &&
        $target.attr("id") !== "shTitle" &&
        !$target.parents("#shNavBar").length
      ) {
        $("#shTopImg").click();
      }
    }
  });
}

function tdentCloseNavMenu($menuContainer, $bodyOverlay, $headerOverlay) {
  /*const menuContainerScrollLockTarget = document.querySelector(
    $menuContainer.attr("id")
  );*/

  $menuContainer.animate({ right: "-100%" }, 900, () => {
    $menuContainer.css("right", "");
    $menuContainer.removeClass("tdent-navbar--menu-show");
  });

  if ($tdentBody.hasClass("tdent-body--noscroll")) {
    $tdentBody.removeClass("tdent-body--noscroll");

    if (!("ontouchstart" in document.documentElement)) {
      $tdentBody.css("padding-right", "");
    }
    //enableBodyScroll(menuContainerScrollLockTarget);
  }

  if (
    $bodyOverlay.length &&
    $bodyOverlay.hasClass("tdent-body__overlay--active")
  ) {
    $bodyOverlay.animate({ opacity: "0" }, 900, () => {
      $bodyOverlay.css("opacity", "");
      $bodyOverlay.removeClass("tdent-body__overlay--active");
    });
  }

  if (
    $headerOverlay.length &&
    $headerOverlay.hasClass("tdent-header__overlay--active")
  ) {
    $headerOverlay.animate({ opacity: "0" }, 900, () => {
      $headerOverlay.css("opacity", "");
      $headerOverlay.removeClass("tdent-header__overlay--active");
    });
  }
}

function tdentInitNavigation() {
  var win = $(window);
  var $headerInit = $("#tdent-header__part--init");
  var $headerFixed = $("#tdent-header__part--fixed");
  var $heroSectionInner = $("#tdent-hero__inner");
  var $menuContainer = $("#tdent-navbar--menu");

  if ($headerInit.length && $headerFixed.length) {
    var headerHeight = 0;
    var scrolledHeight = 0;

    win.on("load resize scroll", event => {
      var screenWidth = windowWidth();
      var koefficientInit = 0.5;
      var koefficientFixed = 0.75;

      scrolledHeight = win.scrollTop();
      headerHeight = $headerInit.outerHeight(true);

      if (
        (event.type === "load" || event.type === "resize") &&
        $heroSectionInner.length
      ) {
        if (screenWidth >= 640) {
          $heroSectionInner.css("padding-top", headerHeight);
        } else {
          $heroSectionInner.css("padding-top", $headerInit.height());
        }
      }

      if (screenWidth <= 567) {
        koefficientInit = 0.2;
        koefficientFixed = 0.4;
      }

      if (scrolledHeight >= koefficientInit * headerHeight) {
        if ($headerInit.hasClass("visible")) {
          $headerInit.removeClass("visible");
        }

        if ($headerInit.hasClass("active")) {
          $headerInit.removeClass("active");
        }

        if (!$headerFixed.hasClass("active")) {
          $headerFixed.addClass("active");

          if (!$headerFixed.hasClass("visible")) {
            setTimeout(() => {
              $headerFixed.addClass("visible");
            }, 300);
          }
        } else {
          if (!$headerFixed.hasClass("visible")) {
            $headerFixed.addClass("visible");
          }
        }
      } else {
        if (scrolledHeight >= koefficientFixed * headerHeight) {
          if ($headerFixed.hasClass("visible")) {
            $headerFixed.removeClass("visible");
          }

          if ($headerFixed.hasClass("active")) {
            setTimeout(() => {
              $headerFixed.removeClass("active");
            }, 300);
          }

          if ($headerInit.hasClass("visible")) {
            $headerInit.removeClass("visible");
          }

          if ($headerInit.hasClass("active")) {
            setTimeout(() => {
              $headerInit.removeClass("active");
            }, 300);
          }
        } else {
          if ($headerFixed.hasClass("visible")) {
            $headerFixed.removeClass("visible");
          }

          if ($headerFixed.hasClass("active")) {
            $headerFixed.removeClass("active");
          }

          if (!$headerInit.hasClass("active")) {
            $headerInit.addClass("active");
          }

          if (!$headerInit.hasClass("visible")) {
            $headerInit.addClass("visible");
          }
        }
      }
    });

    win.resize().scroll();
  }

  if ($menuContainer.length) {
    var $bodyOverlay = $("#tdent-body__overlay");
    var $headerOverlay = $("#tdent-header__overlay");
    var $dropdownLinks = $(".tdent-navbar__link--dropdown-toggle");
    /*const menuContainerScrollLockTarget = document.querySelector(
      $menuContainer.attr("id")
    );*/

    if ($dropdownLinks.length) {
      $dropdownLinks.each(function() {
        var $link = $(this);
        var $linkParent = $link.parent();
        var $dropdownMenu = $linkParent.children(
          ".tdent-navbar__dropdown-menu"
        );

        if ($dropdownMenu.length) {
          var $clone = $dropdownMenu
            .children()
            .first()
            .clone();
          var $cloneLink = $clone.children().first();

          if ($clone.hasClass("tdent-navbar__item--dropdown")) {
            $clone.removeClass("tdent-navbar__item--dropdown");
            $clone.removeClass("dropdown");

            $cloneLink.removeClass("tdent-navbar__link--dropdown-toggle");
            $cloneLink.removeClass("dropdown-toggle");
          }

          $clone.addClass("tdent-navbar__item--parent-clone");
          $clone.attr("id", $linkParent.attr("id") + "-clone");

          $cloneLink.addClass("tdent-navbar__link--parent-clone");
          $cloneLink.attr("id", $link.attr("id") + "-clone");
          $cloneLink.attr("href", $link.attr("href"));
          $cloneLink.removeData("toggle");
          $cloneLink.removeAttr("data-toggle");
          $cloneLink.removeAttr("aria-haspopup");
          $cloneLink.removeAttr("aria-expanded");
          $cloneLink.html($link.html());

          $clone.prependTo($dropdownMenu);
        }
      });

      $(".dropdown-menu .tdent-navbar__link--dropdown-toggle").on(
        "click",
        function() {
          if (!$menuContainer.hasClass("hoverable")) {
            var $link = $(this);
            var $parent = $link.offsetParent(".dropdown-menu");
            var $subMenu = $link.next(".dropdown-menu");

            if (!$subMenu.hasClass("show")) {
              $link
                .parents(".dropdown-menu")
                .first()
                .find(".show")
                .removeClass("show");
            }

            $subMenu.toggleClass("show");

            $link.parent("li").toggleClass("show");

            $link
              .parents("li.nav-item.dropdown.show")
              .on("hidden.bs.dropdown", function() {
                $(".dropdown-menu .show").removeClass("show");
              });

            if (!$parent.parent().hasClass("navbar-nav")) {
              $link.next().css({
                top: $link[0].offsetTop,
                left: $parent.outerWidth() - 4,
              });
            }

            return false;
          }
        }
      );

      $tdentDocument.on(
        "mouseenter",
        ".hoverable .tdent-navbar__item--dropdown",
        function() {
          var $menuItem = $(this);
          var $subMenu = $menuItem.children(".dropdown-menu").first();

          if (
            !$menuItem.hasClass("tdent-navbar__item--level-0") &&
            !$menuItem.hasClass("tdent-navbar__item--level-1")
          ) {
            $subMenu = $menuItem.find(".dropdown-menu");
          }

          if (!$menuItem.hasClass("show")) {
            $menuItem.addClass("show");
            $subMenu.addClass("show");
            $menuItem
              .children(".tdent-navbar__link")
              .first()
              .attr("aria-expanded", "true");
          }
        }
      );

      $tdentDocument.on(
        "mouseleave",
        ".hoverable .tdent-navbar__item--dropdown",
        function() {
          var $menuItem = $(this);

          if ($menuItem.hasClass("show")) {
            $menuItem.removeClass("show");
            $menuItem
              .children(".tdent-navbar__link")
              .first()
              .attr("aria-expanded", "false");

            if (
              $menuItem.hasClass("tdent-navbar__item--level-0") ||
              $menuItem.hasClass("tdent-navbar__item--level-1") ||
              $menuItem.hasClass("tdent-navbar__item--level-2")
            ) {
              var $subMenu = $menuItem.find(".dropdown-menu");

              $subMenu.removeClass("show");
            }
          }
        }
      );

      $(".dropdown").on("hidden.bs.dropdown", function() {
        // hide any open menus when parent closes
        $(".dropdown-menu.show").removeClass("show");
      });
    }

    $tdentDocument.on(
      "click",
      "#tdent-navbar__toggler--init-open, #tdent-navbar__toggler--fixed-open",
      function() {
        if ($menuContainer.hasClass("tdent-navbar--menu-show")) {
          tdentCloseNavMenu($menuContainer, $bodyOverlay, $headerOverlay);
        } else {
          if (!$tdentBody.hasClass("tdent-body--noscroll")) {
            $tdentBody.addClass("tdent-body--noscroll");

            if (!("ontouchstart" in document.documentElement)) {
              $tdentBody.css("padding-right", tdentScrollWidth);
            }
            //disableBodyScroll(menuContainerScrollLockTarget);
          }

          $menuContainer.animate({ right: "0" }, 900, () => {
            $menuContainer.addClass("tdent-navbar--menu-show");
          });

          if ($bodyOverlay.length) {
            $bodyOverlay.addClass("tdent-body__overlay--active");
            $bodyOverlay.animate({ opacity: "1" }, 900);
          }

          if ($headerOverlay.length) {
            $headerOverlay.addClass("tdent-header__overlay--active");
            $headerOverlay.animate({ opacity: "1" }, 900);
          }
        }
      }
    );

    $tdentDocument.on("click", "#tdent-navbar__toggler--close", function() {
      if ($menuContainer.hasClass("tdent-navbar--menu-show")) {
        tdentCloseNavMenu($menuContainer, $bodyOverlay, $headerOverlay);
      }
    });

    $tdentDocument.keyup(function(e) {
      if (e.which == 27 && $menuContainer.hasClass("tdent-navbar--menu-show")) {
        tdentCloseNavMenu($menuContainer, $bodyOverlay, $headerOverlay);
      }
    });

    $tdentDocument.on("click", function(e) {
      var $target = $(e.target);

      if (
        ($target.hasClass("tdent-navbar__link") &&
          $menuContainer.hasClass("tdent-navbar--menu-show")) ||
        (!$target.hasClass(".tdent-navbar__toggler--open") &&
          !$target.hasClass(".tdent-navbar__toggler--close") &&
          !$target.parents(".tdent-navbar__nav").length &&
          $menuContainer.hasClass("tdent-navbar--menu-show"))
      ) {
        tdentCloseNavMenu($menuContainer, $bodyOverlay, $headerOverlay);
      }
    });

    $tdentWindow.on("load resize", () => {
      if (
        windowWidth() >= 992 &&
        !("ontouchstart" in document.documentElement) &&
        !$menuContainer.hasClass("hoverable")
      ) {
        $menuContainer.addClass("hoverable");

        if ($dropdownLinks.length) {
          $dropdownLinks.removeData("toggle");
          $dropdownLinks.removeAttr("data-toggle");
        }
      } else if (
        (windowWidth() < 992 || "ontouchstart" in document.documentElement) &&
        $menuContainer.hasClass("hoverable")
      ) {
        $menuContainer.removeClass("hoverable");

        if ($dropdownLinks.length) {
          $dropdownLinks.attr("data-toggle", "dropdown");
          $dropdownLinks.data("toggle", "dropdown");
        }
      }
    });
  }
}

function tdentInitParallax() {
  var $heroParallax = $("#tdent-hero__parallax");
  var $heroParallaxMirror = null;

  if ($heroParallax.length) {
    var imageSrc = $heroParallax.data("image-src");
    var $heroParallaxMirrorImages = $(".parallax-mirror .parallax-slider");

    if (imageSrc && $heroParallaxMirrorImages.length) {
      $heroParallaxMirrorImages.each(function() {
        var $this = $(this);

        if ($this.attr("src") === imageSrc) {
          $heroParallaxMirror = $this.parent();
        }
      });
    }

    if ($heroParallaxMirror.length) {
      var screenWidth = windowWidth();

      $tdentWindow.on("resize", () => {
        var currentScreenWidth = windowWidth();

        if (currentScreenWidth >= 1024 && screenWidth < 1024) {
          $heroParallax.css("background-image", "none");
          $heroParallaxMirror.css("visibility", "visible");
        } else if (currentScreenWidth < 1024 && screenWidth >= 1024) {
          $heroParallax.css("background-image", "");
          $heroParallaxMirror.css("visibility", "hidden");
        }

        screenWidth = currentScreenWidth;
      });
    }
  }

  if ($heroParallax.length) {
    $tdentWindow.trigger("resize.px.parallax");
    $tdentWindow.resize().scroll();

    $tdentWindow.on("load", () => {
      $tdentWindow.trigger("resize.px.parallax");
      $tdentWindow.resize().scroll();

      if (windowWidth() >= 1024) {
        $heroParallax.css("background-image", "none");

        if ($heroParallaxMirror.length) {
          $heroParallaxMirror.css("visibility", "visible");
        }
      }
    });
  }
}

/* eslint-disable */
/*function tdentStickyBgResize(
  stickyBgBlock,
  $bgBlock,
  $headerFixed,
  $contentBlock
) {
  var blockHeight = windowHeight();
  var contentHeight = $contentBlock.innerHeight();

  if ($headerFixed.length) {
    var fixedInactive = false;

    if (!$headerFixed.hasClass("active")) {
      fixedInactive = true;

      $headerFixed.addClass("active");
    }

    setTimeout(function() {
      var headerFixedHeight = $headerFixed.innerHeight();
      blockHeight -= headerFixedHeight;

      if (fixedInactive) {
        $headerFixed.removeClass("active");
      }

      setTimeout(function() {
        if (blockHeight > contentHeight) {
          blockHeight = contentHeight;
        }

        $bgBlock.height(blockHeight);

        stickyBgBlock.destroy();

        stickyBgBlock = new StickySidebar("#tdent-article__part--home-image", {
          topSpacing: headerFixedHeight,
          bottomSpacing: 0,
          innerWrapperSelector: "#tdent-article__sticky-bg",
        });
      }, 100);
    }, 200);
  } else {
    if (blockHeight > contentHeight) {
      blockHeight = contentHeight;
    }

    $bgBlock.height(blockHeight);

    stickyBgBlock.updateSticky();
  }
}

function tdentStickyBg() {
  var $bgBlock = $(
    ".tdent-article__part--left-to-right #tdent-article__sticky-bg"
  );
  var $headerFixed = $("#tdent-header__part--fixed");

  if ($bgBlock.length) {
    var $contentBlock = $bgBlock
      .closest(".tdent-article__section--home-content")
      .find(".tdent-article__container--home-content");
    var stickyBgBlock = new StickySidebar("#tdent-article__part--home-image", {
      topSpacing: 0,
      bottomSpacing: 0,
      innerWrapperSelector: "#tdent-article__sticky-bg",
    });

    tdentStickyBgResize(stickyBgBlock, $bgBlock, $headerFixed, $contentBlock);

    $tdentWindow.on("load resize", function() {
      tdentStickyBgResize(stickyBgBlock, $bgBlock, $headerFixed, $contentBlock);
    });
  }
}*/
/* eslint-enable */

/* function tdentHomeContentBg() {
  var $homeContentBg = $("#tdent-article__part-home-pic");

  if ($homeContentBg.length) {
    picturefill({
      elements: [document.getElementById("tdent-article__part-home-pic")],
    });
  }
} */

function tdentSetCopyrightYear() {
  var $yearElement = $(".tdent-copyright__year");

  if ($yearElement.length) {
    var currentDate = new Date();

    $yearElement.html(currentDate.getFullYear());
  }
}

function tdentSetFooterPosition($footer) {
  var freeDistance =
    windowHeight() - $footer.position().top - $footer.innerHeight();

  if (freeDistance > 0) {
    $footer.css({ "margin-top": freeDistance + "px" });
  }
}

function tdentPlaceTheFooter() {
  var $footer = $("#footer");

  if ($footer.length) {
    tdentSetFooterPosition($footer);

    $(window).on("load resize", () => {
      tdentSetFooterPosition($footer);
    });
  }
}

jQuery(document).ready(() => {
  tdentHandleAnchorLinks();
  tdentHandleButtonsFocus();
  getScrollWidth();
  tdentFixPlaceholders();
  tdentFixFrames();
  tdentFixNextGenShutter();
  tdentInitNavigation();
  tdentInitParallax();
  //tdentStickyBg();
  //tdentHomeContentBg();
  tdentSetCopyrightYear();
  tdentPlaceTheFooter();
});



// WEBPACK FOOTER //
// ./scripts/main.js